import computeLayoutMatrix from './computeLayoutMatrix';
import {NEW_CELL_PREFIX} from '../constants';
import type {
  CellId,
  CellLocation,
  LayoutLocations,
  LayoutMatrix,
} from '../types';

/**
 * Computes the target Layout matrix when un-merging a Cell
 */
const computeUnmergedMatrix = (
  cellId: CellId,
  locations: LayoutLocations
): LayoutMatrix => {
  const location = locations[cellId];
  if (!location) {
    return [];
  }

  const newLocations = computeNewCellsLocations(cellId, location);
  const targetLocations = {
    ...locations,
    ...newLocations,
  } as const;
  return computeLayoutMatrix(targetLocations);
};

/**
 * Splits up a given Cell into N locations where at the top-left we have the
 * existing Cell and the other slots are filled with N-1 1x1 Cells.
 */
function computeNewCellsLocations(
  cellId: CellId,
  location: CellLocation
): LayoutLocations {
  const {gridRowStart, gridRowEnd, gridColumnStart, gridColumnEnd} = location;
  const locations: Record<string, any> = {};

  for (let row = gridRowStart; row < gridRowEnd; row++) {
    for (let col = gridColumnStart; col < gridColumnEnd; col++) {
      // Existing cell moves to the top-left
      const isTopLeft = row === gridRowStart && col === gridColumnStart;
      const key = isTopLeft ? cellId : `${NEW_CELL_PREFIX}_${row}_${col}`;
      locations[key] = {
        gridRowStart: row,
        gridRowEnd: row + 1,
        gridColumnStart: col,
        gridColumnEnd: col + 1,
      };
    }
  }

  return locations;
}

export default computeUnmergedMatrix;
